// Internal
import appTypes from 'shared/utils/actions';
import { OPEN, CLOSE } from 'shared/constants/actions';

const modal = appTypes.defineAction('modal');

const MODAL = modal.defineAction('MODAL', [OPEN, CLOSE]);

export default MODAL;
